import "../ui/app.css";
import { trackEvent } from "../analytics";
import { install as installErrorBoundary, guard } from "../errorBoundary";
import { installConsent } from "../consent";
import { mountFooter } from "../shared/footer";
import { loadAdSenseOnConsent } from "../ads/adsense";
import { renderMethodology } from "./methodology";

const page = document.querySelector<HTMLElement>("#page");
if (page) {
  installErrorBoundary(page);
  guard(() => {
    page.classList.add("content-page");
    // REN-65: scripts/prerender.mjs runs this same renderer at build time and
    // ships the result in the static HTML, so crawlers see the full page.
    // Only render client-side when that shell is empty (dev server).
    if (page.dataset.prerendered !== "true") {
      page.append(renderMethodology());
    }
  });
}

// REN-83: the content surface was emitting no telemetry at all.
trackEvent("visit");

const consent = installConsent();
mountFooter();
loadAdSenseOnConsent({ consent });
